export const validateHtml = (userResult, validAnswer) => userResult === validAnswer;
